import { Injectable, inject } from '@angular/core';
import { catchError, map, Observable, of } from 'rxjs';
import { IncentivePartnerService } from '@coin/shared/core/data-access';
import { IncentiveRecordsAchievementRecordModel, SearchItemService } from '@coin/shared/core/util-models';
import { IncentiveSupportComponentState } from './incentive-support.component.state';

@Injectable()
export class AchievementSearchService implements SearchItemService {
  private incentiveSupportComponentState = inject(IncentiveSupportComponentState);
  private incentiveAchievementService = inject(IncentivePartnerService);

  getSearchItemsByText(text: string, page: number): Observable<IncentiveRecordsAchievementRecordModel[]> {
    const selectedSeason = this.incentiveSupportComponentState.getSelectedSeason();
    if (!selectedSeason) {
      throw new Error('Cannot load records without selected season');
    }
    return this.incentiveAchievementService
      .queryAchievements({
        seasonId: selectedSeason.id,
        pagingPage: page + 1,
        pagingSize: 50,
        queryGid: [text]
      })
      .pipe(
        map(result => result.content),
        // Return empty list in case of an error to prevent an error in the view
        catchError(() => of([]))
      );
  }
}
